import React from "react";
import "./Footer.css";
import mainlogo from "../../assets/mainlogo.png";
import { Link } from "react-router-dom";

import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaTwitter,
  FaYoutube,
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaArrowRight,
  FaHeadset,
  FaWhatsapp,
  FaTiktok
} from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">

      <div className="footer-container">

        {/* =========================
            MAIN FOOTER
        ========================= */}

        <div className="footer-main">

          {/* BRAND / CONTACT */}
          <div className="footer-brand">

            {/* Logo */}
            
              <img
                src={mainlogo}
                alt="Adviz Media"
                className="footer-main-logo"
              />
          

            <p className="footer-description">
              Specialized Google and Meta ads management for plumbing, HVAC, waterproofing, and restoration contractors across US, UK, and UAE.
            </p>

            {/* Email */}
            <a
              href="mailto:info@advizmedia.com"
              className="contact-link"
            >
              <span className="contact-icon">
                <FaEnvelope />
              </span>

              <span>info@advizmedia.com</span>
            </a>

            {/* Phone */}
            <a
              href="tel:+18881234567"
              className="contact-link"
            >
              <span className="contact-icon">
                <FaPhone />
              </span>

              <span>+92 (306) 8828558</span>
            </a>

            {/* Location */}
            

            {/* Social */}
            <div className="social-wrapper">

              <h4>FOLLOW US</h4>

              <div className="social-links">

                <a href="https://www.facebook.com/maoozppc" aria-label="Facebook">
                  <FaFacebookF />
                </a>

                <a href="https://www.instagram.com/maooz.digital?stkn=OTE5Z2NteGwyOWJk&utm_source=qr" aria-label="Instagram">
                  <FaInstagram />
                </a>

                <a href="https://www.linkedin.com/in/maoozahmad/" aria-label="LinkedIn">
                  <FaLinkedinIn />
                </a>

                <a href="#" aria-label="Twitter">
                  <FaTwitter />
                </a>

                <a href="https://www.tiktok.com/@maoozdigital?_r=1&_t=ZS-99Z9AkUfTme" aria-label="TikTok">
                  <FaTiktok />
                </a>

              </div>

            </div>

          </div>


          {/* SERVICES */}
          <div className="footer-column">

            <h3>SERVICES</h3>

            <ul>

              <li>
                <Link to="/services/google-search-ads">
                  <span>Google Search Ads</span>
                  <FaArrowRight />
                </Link>
              </li>

              <li>
                <Link to="/services/local-services-ads">
                  <span>Local Services Ads (LSA)</span>
                  <FaArrowRight />
                </Link>
              </li>

              <li>
                <Link to="/services/meta-lead-ads">
                  <span>Meta Lead Ads</span>
                  <FaArrowRight />
                </Link>
              </li>

              <li>
                <Link to="/services/seo">
                  <span>SEO</span>
                  <FaArrowRight />
                </Link>
              </li>

              <li>
                <Link to="/services/web-development">
                  <span>Web Development</span>
                  <FaArrowRight />
                </Link>
              </li>

              <li>
                <Link to="/services/ai-video-creation">
                  <span>AI Video Creation</span>
                  <FaArrowRight />
                </Link>
              </li>

            </ul>

          </div>


          {/* COMPANY */}
          <div className="footer-column">

            <h3>COMPANY</h3>

            <ul>

              <li>
                <Link to="/about">
                  <span>About Us</span>
                  <FaArrowRight />
                </Link>
              </li>

              

              <li>
                <Link to="/casestudies">
                  <span>Case Study</span>
                  <FaArrowRight />
                </Link>
              </li>

              <li>
                <Link to="/contact">
                  <span>Contact Us</span>
                  <FaArrowRight />
                </Link>
              </li>
              

            </ul>

          </div>


          {/* LEGAL + CTA */}
          <div className="footer-right">

            <div className="footer-column legal-column">

              <h3>LEGAL</h3>

              <ul>

                <li>
                  <a href="#">
                    <span>Privacy Policy</span>
                    <FaArrowRight />
                  </a>
                </li>

                <li>
                  <a href="#">
                    <span>Terms of Service</span>
                    <FaArrowRight />
                  </a>
                </li>

                <li>
                  <a href="#">
                    <span>Cookie Policy</span>
                    <FaArrowRight />
                  </a>
                </li>

                <li>
                  <a href="#">
                    <span>Refund Policy</span>
                    <FaArrowRight />
                  </a>
                </li>

              </ul>

            </div>


            {/* CTA CARD */}

          </div>

        </div>


        {/* =========================
            BOTTOM FOOTER
        ========================= */}

        <div className="footer-bottom">

          <p>
            © 2026 Adviz Media. All rights reserved.
          </p>

          <div className="bottom-links">

            <a href="#">Sitemap</a>

            <span>•</span>

            <a href="#">Privacy Policy</a>

            <span>•</span>

            <a href="#">Terms of Service</a>

          </div>

        </div>

      </div>


      {/* =========================
          WHATSAPP BUTTON
      ========================= */}

      <a
        href="https://wa.me/03068828558?text=Hello%20Adwiz%2C%20I%20would%20like%20to%20book%20a%20free%20Google%20Ads%20audit.%20Please%20let%20me%20know%20how%20we%20can%20get%20started."
        className="whatsapp-button"
        aria-label="Chat with us on WhatsApp"
      >
        <FaWhatsapp />
      </a>

    </footer>
  );
};

export default Footer;